import React from "react";
import '../css/Footer.css'


function Footer(props) {
    const trademark = '© ' + new Date().getFullYear() + ", Rexius Algorithms LLC."
    const reserved = 'All rights reserved.'
    return (
        <footer>
            <div className={"container-fluid"}>
                <div className="row">
                    <div className={"footer"}>
                        <div className={"footer-text"}>
                            {/*<div className={"trademark"} style={{color: props.footerColor}}>{trademark}</div>*/}
                            {/*<div className={"reserved"} style={{color: props.footerColor}}>{reserved}</div>*/}
                            {/*<a className={"terms-link"} style={{color: props.footerColor}} target="_blank" rel="noopener noreferrer" href="http://rexiusalgorithms.com/terms">Terms</a>*/}
                            <div className={"trademark"}>{trademark}</div>
                            <div className={"reserved"}>{reserved}</div>
                            <a className={"terms-link"} target="_blank" rel="noopener noreferrer" href="https://pineapplespin.com/terms">Terms</a>

                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;